import { Switch, Route } from 'react-router-dom';
import PlaylistsView from './PlaylistsView';
import PlaylistDetailView from './PlaylistDetailView';

export default function PlaylistsRouter() {
  return (
    <Switch>
      <Route path="/me/playlists" exact component={PlaylistsView} />
      <Route path="/me/playlists/:id" exact component={PlaylistDetailView} />
    </Switch>
  );
}
